import { imageNames } from "@/src/constants/imageConstants.js";

export const themeTypes = {
  DARK: "DARK",
  LIGHT: "LIGHT",
  AUTO: "AUTO",
};

export const themeOptions = [
  { label: "Auto", value: themeTypes.AUTO, icon: imageNames.AUTO_THEME_GREY },
  {
    label: "Light",
    value: themeTypes.LIGHT,
    icon: imageNames.LIGHT_THEME_GREY,
  },
  { label: "Dark", value: themeTypes.DARK, icon: imageNames.DARK_THEME_GREY },
];
